import {
	type Message as ReactHookFormMessage,
	useFormContext,
} from 'react-hook-form';

import Message from 'components/Message';
import ScreenReaderAnnouncementText from 'components/ScreenReaderAnnouncementText';
import { is } from 'utils/helpers';

interface Props {
	className?: string;
	/** Defaults to the root errors of the surrounding form. */
	errors?:
		| (Record<
				string,
				Partial<{
					type: string | number;
					message: ReactHookFormMessage;
				}>
		  > &
				Partial<{
					type: string | number;
					message: ReactHookFormMessage;
				}>)
		| undefined;
}

export default function ErrorMessageInfoBox({ className, errors }: Props) {
	const { formState } = useFormContext();
	const rootErrors = errors ?? formState.errors.root;
	if (!rootErrors) return null;
	const generalErrorMessages = Object.entries(rootErrors)
		.map(([, value]) =>
			is.object(value) && 'message' in value
				? value.message
				: is.string(value)
					? value
					: undefined,
		)
		.filter(is.truthy);
	return (
		<ScreenReaderAnnouncementText
			as="div"
			text={
				is.arrayWithLength(generalErrorMessages) ? (
					<Message
						variant="error"
						className={className}
						text={generalErrorMessages.join('\n\n')}
					/>
				) : undefined
			}
		/>
	);
}
ErrorMessageInfoBox.displayName = 'ReactHookForm_ErrorMessageInfoBox';
